import { defineStore } from 'pinia';

export const useAppStore = defineStore('app', {
  state: () => ({
    drawer: true,
    loading: false,
    currentPage: 1,
    currentTrack: 0,
    fileName: "",
    // fileName: "Abba-Gold-greatestHits",
    file: "",
    // file: "https://data.tdot.men/pdf/Abba-Gold-greatestHits.pdf",
    files: []
  }),
  actions: {
    setTrack(value: number) {
      this.currentTrack = value;
    },
    setPage(value: number) {
      this.currentPage = value;
    },
    resetFile() {
      this.fileName = "";
      this.file = "";
    },
    showIndexedOnly() {
      const results = this.files.filter(f => JSON.parse(JSON.stringify(f)).songs.length > 0);
      return results;
    },
    find(value: string) {

      const results = this.files.filter(f => (JSON.stringify(f).toLowerCase().includes(value.toLowerCase())));

      return results;

   },
  }
})
